import { STATS_API } from "../../constants";
import { apiSlice } from "../api-slice";
import { GetPlayingSurfaceById, PlayingSurface } from "./types";

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAllPlayingSurfaces: build.query<PlayingSurface[], void>({
      query: () => `${STATS_API}/query/court/all`,
    }),
    getPlayingSurfaceById: build.query<PlayingSurface, GetPlayingSurfaceById>({
      query: ({ id }) => `${STATS_API}/query/court?league=${id}`,
    }),
  }),
});

export const {
  useGetAllPlayingSurfacesQuery,
  useLazyGetAllPlayingSurfacesQuery,
  useGetPlayingSurfaceByIdQuery,
  useLazyGetPlayingSurfaceByIdQuery,
} = extendedApi;
